import { render, staticRenderFns } from "./switchClient.vue?vue&type=template&id=c4d988d4&scoped=true"
import script from "./switchClient.vue?vue&type=script&lang=js"
export * from "./switchClient.vue?vue&type=script&lang=js"
import style0 from "./switchClient.vue?vue&type=style&index=0&id=c4d988d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d988d4",
  null
  
)

export default component.exports